(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class announcementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setPromoHeight();
      window.matchMedia('(max-width: 768px)').addEventListener('change', this.setPromoHeight.bind(this));
    }

    setPromoHeight() {
      document.documentElement.style.setProperty('--promo-height', `${this.offsetHeight}px`);
    }
  }

  customElements.define('announcement-bar', announcementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class Header extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.isScrolled = false;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (!this.isScrolled && scrollTop > 220) {
      this.isScrolled = true;
      this.header.classList.add('scrolled-past-header');
      document.body.classList.add('scrolled');

      setTimeout(() => {
        document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-bottom-position',`${this.header.getBoundingClientRect().bottom}px`);
      }, 201);
    }

    if (this.isScrolled && scrollTop < 180) {
      this.isScrolled = false;
      this.header.classList.remove('scrolled-past-header');
      document.body.classList.remove('scrolled');

      setTimeout(() => {
        document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);
        document.documentElement.style.setProperty('--header-bottom-position',`${this.header.getBoundingClientRect().bottom}px`);
      }, 201);
    }

  }
}

customElements.define('site-header', Header);



  } catch(e) { console.error(e); }
})();
})();
